import { render, staticRenderFns } from "./SaleEdit.vue?vue&type=template&id=3b36efd4&scoped=true&"
import script from "./SaleEdit.vue?vue&type=script&lang=js&"
export * from "./SaleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b36efd4",
  null
  
)

export default component.exports